'use client';

import { Button } from '@mui/material';
import { useAction } from 'next-safe-action/hooks';
import { type ComponentProps, type FC, useCallback } from 'react';
import {
  type ConnectResultSchemaT,
  ConnectToToolAction,
} from './connect-to-tool.action';

type Tool = {
  id: string;
  function_url: string;
};

type Props = Omit<ComponentProps<typeof Button>, 'onClick'> & {
  tool: Tool;
  onClick?: (data: ConnectResultSchemaT | undefined) => void;
};

export const ConnectToToolBtn: FC<Props> = (props) => {
  const { tool, disabled = false, onClick = undefined, ...rest } = props;

  const { execute, status } = useAction(ConnectToToolAction, {
    onSuccess: ({ data }) => {
      if (onClick) {
        onClick(data);
      }
    },
  });

  const onConnect = useCallback(() => {
    execute({
      tool,
    });
  }, [execute, tool]);

  return (
    <Button
      onClick={onConnect}
      disabled={disabled || status === 'executing'}
      {...rest}
    />
  );
};
